import { render, staticRenderFns } from "./CompanyAlarmNews.vue?vue&type=template&id=709e2053&scoped=true&"
import script from "./CompanyAlarmNews.vue?vue&type=script&lang=js&"
export * from "./CompanyAlarmNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709e2053",
  null
  
)

export default component.exports